export default "__VITE_ASSET__CbErn72P__"